import { ProductCatalogApiClient } from '@fourthwall/services/dist/ProductCatalogApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteProductFromFavoritesMutation = createMutationHook(
  ProductCatalogApiClient.deleteProductFromFavorite,
  {
    mutationKey: ['deleteProductFromFavorites'],
  },
)
